export const AUTH = "AUTH"

export const UNAUTH = "UNAUTH"